import dat from 'dat.gui';
import { sync } from 'vuex-pathify';

// import Keypress from 'keypress.js';

import siteOptions from './site-options';
import jobs from './jobs';
import actions from './actions';
import fonts from './fonts';

export default {

  mixins: [
    siteOptions,
    jobs,
    actions,
    fonts,
  ],

  data() {
    return {
      dat: null,
      guiFolder: null,
      jobFolder: null,

      guiSettings: {
        // background: false,
      },

      guiOptions: {
        autoPlace: true,
        closed: false,
        // hideable: false,
        // width: 400,
      },
    };
  },

  computed: {
    ...sync([
      'site.activeFont', //
      'site.thumbnails',
    ]),
  },

  methods: {
    initDatGui() {
      this.datGui = new dat.GUI(this.datGuiOptions);

      // this.datGui.close();

      if (!this.$route.query.debug) {
        dat.GUI.toggleHide();
      }

      // const listener = new Keypress.Listener();

      // listener.simple_combo('k', (evt) => {
      //   if (evt.target.type === 'text' || evt.target.type === 'email' || evt.target.type === 'password' || evt.target.className.includes('cke_editable')) return true;
      //   dat.GUI.toggleHide();
      //   return false;
      // });
    },

    loadGuiItems() {
      const self = this;

      this.guiFolder = this.datGui.addFolder('GUI');

      const GuiItemOptions = function guiItemOptions() {
        this.font = self.activeFont;
        this.colorPicker = () => {
          Bus.$emit('toggle_color_picker');
        };
      };

      const obj = new GuiItemOptions();

      const fontController = this.guiFolder.add(obj, 'font', this.fonts);

      fontController.onFinishChange((font) => {
        Bus.$emit('update_font', font);
      });

      this.guiFolder.add(obj, 'colorPicker');

      // const body = document.querySelector('body');
      // this.datGui.add(this.guiSettings, 'background').onChange(() => body.classList.toggle('background'));
    },

    loadTubeItems() {
      const self = this;

      this.tubeFolder = this.datGui.addFolder('Tube');

      const TubeItemOptions = function tubeItemOptTubes() {
        Object.keys(self.siteOptions).forEach((k) => {
          this[self.siteOptions[k].storePath] = self.$store.get(self.siteOptions[k].storePath);
        });
      };

      const obj = new TubeItemOptions();

      Object.keys(this.siteOptions).forEach((k) => {
        this.tubeFolder.add(obj, this.siteOptions[k].storePath).name(this.siteOptions[k].label).onChange(() => { this.$store.set(this.siteOptions[k].storePath, !this.$store.get(this.siteOptions[k].storePath)); });
      });
    },

    loadJobItems() {
      this.jobFolder = this.datGui.addFolder('Jobs');

      const obj = { runJob: () => {} };

      Object.keys(this.jobs).forEach((k) => {
        this.jobFolder.add(obj, 'runJob').name(this.jobs[k].label).onChange(() => { Bus.$emit('run_job', this.jobs[k].name); });
      });

      // this.jobFolder.open();
    },

    loadActionItems() {
      this.actionFolder = this.datGui.addFolder('Actions');

      const obj = { runAction: () => {} };

      Object.keys(this.actions).forEach((k) => {
        this.actionFolder.add(obj, 'runAction').name(this.actions[k].label).onChange(() => { Bus.$emit(this.actions[k].name); });
      });

      // this.actionFolder.open();
    },
  },

  mounted() {
    this.initDatGui();
    this.loadGuiItems();
    this.loadTubeItems();
    this.loadJobItems();
    this.loadActionItems();
  },

  beforeDestroy() {
    this.datGui.destroy();
  },
};
